export const PRIVACY_CONSENT_NOTICE = {
  hi: {
    title: "गोपनीयता एवं सहमति सूचना",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1. यह सूचना आपको यह बताने के लिए है कि हम, कॉर्टेवा एग्रीसाइंस इंडिया प्राइवेट लिमिटेड, इसकी मूल कंपनी और सहयोगी कंपनियाँ ('कॉर्टेवा एग्रीसाइंस'), आपके व्यक्तिगत डेटा को किस प्रकार संसाधित करना चाहते हैं, ताकि आप अपनी सूचित सहमति प्रदान कर सकें।",
      },
      {
        type: "heading",
        text: "संग्रहित एवं संसाधित व्यक्तिगत डेटा",
      },
      {
        type: "paragraph",
        text: "2. कॉर्टेवा द्वारा आपसे एकत्र किए जाने वाले व्यक्तिगत डेटा के प्रकार इस बात पर निर्भर करते हैं कि आप कॉर्टेवा के साथ किस प्रकार संपर्क करते हैं और उन संपर्कों के दौरान आप कौन-सा व्यक्तिगत डेटा प्रदान करते हैं। सामान्यतः, कॉर्टेवा आपसे निम्नलिखित व्यक्तिगत जानकारी एकत्र और संसाधित करेगा। इस सूचना में उल्लिखित उद्देश्यों के लिए केवल निम्नलिखित व्यक्तिगत डेटा ही एकत्र किया जाएगा:",
      },
      {
        type: "list",
        items: [
          "I. नाम:",
          "II. फ़ोन नंबर:",
          "III. क्षेत्र/स्थान:",
        ],
      },
      {
        type: "heading",
        text: "व्यक्तिगत डेटा का प्रसंस्करण",
      },
      {
        type: "paragraph",
        text: "3. उपर्युक्त सूचीबद्ध व्यक्तिगत डेटा का उपयोग निम्नलिखित उद्देश्यों के लिए किया जाएगा, जब लागू कानून के अंतर्गत कॉर्टेवा के पास वैध आधार हो या आपकी स्पष्ट सहमति प्राप्त हो। कॉर्टेवा तथा उसके सेवा प्रदाता व्यक्तिगत डेटा का उपयोग निम्नलिखित उद्देश्यों के लिए करेंगे:",
      },
      {
        type: "list",
        items: [
          "I. आपका नाम, फ़ोन नंबर और ईमेल का उपयोग आपको डेलीगेट एवं डेलीगेट डबल धमाका कैशबैक कार्यक्रम के ग्राहक के रूप में पंजीकृत करने के लिए किया जाएगा।",
          "II. आपके क्षेत्र/स्थान का उपयोग वस्तुओं एवं सेवाओं की आपूर्ति के लिए किया जाएगा।",
        ],
      },
      {
        type: "paragraph",
        text: "4. आपका व्यक्तिगत डेटा भारत के बाहर भी संग्रहीत या संसाधित किया जा सकता है। कॉर्टेवा केवल उतना ही व्यक्तिगत डेटा एकत्र और संसाधित करता है जितना उपर्युक्त उद्देश्यों की पूर्ति के लिए आवश्यक है। व्यक्तिगत डेटा का उपयोग किसी अन्य उद्देश्य के लिए नहीं किया जाएगा।",
      },
      {
        type: "heading",
        text: "व्यक्तिगत डेटा का संरक्षण",
      },
      {
        type: "paragraph",
        text: "5. कॉर्टेवा व्यक्तिगत डेटा को उतनी अवधि तक सुरक्षित रखता है जितनी अवधि तक वह आवश्यक या अनुमत हो, उस उद्देश्य को ध्यान में रखते हुए जिसके लिए उसे प्राप्त किया गया था तथा लागू कानून के अनुरूप। हमारी संरक्षण अवधि निर्धारित करने के लिए निम्नलिखित मानदंड अपनाए जाते हैं:",
      },
      {
        type: "list",
        items: [
          "I. कॉर्टेवा के साथ आपके संबंध की अवधि तथा उसके बाद की वह अवधि जिसके दौरान उत्पन्न होने वाले किसी भी मुद्दे के समाधान हेतु आपके व्यक्तिगत डेटा की आवश्यकता हो सकती है।",
          "II. क्या कॉर्टेवा पर कोई कानूनी दायित्व लागू है (उदाहरण के लिए, कुछ कानूनों के अनुसार हमें आपके लेन-देन के अभिलेख एक निश्चित अवधि तक सुरक्षित रखने होते हैं)।",
          "III. क्या कॉर्टेवा की कानूनी स्थिति (जैसे लागू सीमा अवधि, मुकदमेबाजी या नियामकीय जांच) को ध्यान में रखते हुए डेटा सुरक्षित रखना उचित है। आपका व्यक्तिगत डेटा केवल तब तक संसाधित किया जाएगा जब तक उपर्युक्त उद्देश्य पूरे नहीं हो जाते:",
        ],
      },
      {
        type: "list",
        items: [
          "a) आपका नाम, फ़ोन नंबर और ईमेल केवल तब तक सुरक्षित रखा जाएगा जब तक आप हमारे ग्राहक बने रहेंगे।",
          "b) आपका क्षेत्र/स्थान केवल तब तक सुरक्षित रखा जाएगा जब तक वस्तुएँ एवं सेवाएँ प्रदान नहीं कर दी जातीं।",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "आपके गोपनीयता अधिकार",
      },
      {
        type: "paragraph",
        text: "6. आप किसी भी समय अपने व्यक्तिगत डेटा के प्रसंस्करण के लिए दी गई सहमति वापस ले सकते हैं। इसके लिए https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in पर जाकर दिए गए निर्देशों का पालन करें। यदि आप ऐसा करते हैं, तो आपका व्यक्तिगत डेटा हटा दिया जाएगा, जब तक कि उसे सुरक्षित रखने की कोई कानूनी आवश्यकता न हो।",
      },
      {
        type: "paragraph",
        text: "7. आप अपने अधिकारों का प्रयोग कर सकते हैं, अपने व्यक्तिगत डेटा के प्रसंस्करण से संबंधित कोई भी प्रश्न पूछ सकते हैं या शिकायत दर्ज करा सकते हैं। इसके लिए हमसे यहाँ संपर्क करें: https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html अथवा ग्राहक सूचना केंद्र, कॉर्टेवा एग्रीसाइंस, 12वीं मंज़िल, एट्रिया, वी एसेन्डास आईटी पार्क, माधापुर, हैदराबाद - 500081 या 1860 1800 186 पर संपर्क करें। यदि आपकी शिकायत का समाधान हमारे द्वारा नहीं किया जाता है, तो आप लागू कानून के अनुसार भारत के डेटा संरक्षण बोर्ड के समक्ष शिकायत दर्ज करा सकते हैं।",
      },
      {
        type: "paragraph",
        text: "मैं पुष्टि करता/करती हूँ कि मैंने इस गोपनीयता सूचना को पढ़ लिया है और समझ लिया है तथा ऊपर वर्णित अनुसार मेरे व्यक्तिगत डेटा के संग्रह और प्रसंस्करण के लिए अपनी सहमति प्रदान करता/करती हूँ।",
        emphasis: true,
      },
    ],
  },
  en: {
    title: "Privacy and Consent Notice",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1.	This Notice is to inform you of how we, Corteva Agriscience India Private Limited, its parent company and affiliates (“Corteva Agriscience”) want to process your personal data, so that you may give your informed consent.",
      },
      {
        type: "heading",
        text: "Personal Data Collected and Processed",
      },
      {
        type: "paragraph",
        text: "2.	The types of Personal Data Corteva may collect from you may vary depending on how you interact with Corteva and what Personal Data you provide in those interactions. Generally, Corteva will collect from you and process the following personal information. Only the following personal data will be collected from you for the purposes mentioned in this notice:",
      },
      {
        type: "list",
        items: ["I. Name:", "II. Phone No.:", "III.	Area/Location:"],
      },
      {
        type: "heading",
        text: "Processing of Personal Data",
      },
      {
        type: "paragraph",
        text: "3.	The purposes for which the personal data listed above will be used are as follows when Corteva has a legitimate basis under applicable law or with your express consent, Corteva its service providers shall use Personal Data for the following purposes.:",
      },
      {
        type: "list",
        items: [
          "I.	Name, Phone No. and Email will be used to register you as a customer for Delegate and Delegate Double Dhamaka Cashback Program",
          "II. Area/Location will be used to provide goods and services."
        ],
      },
      {
        type: "paragraph",
        text: "4.	Your Personal Data may be stored or processed outside India. Corteva only collects as much and processes the Personal Data as is necessary for the above purposes. We will only collect as much personal data as is necessary for the purposes mentioned. The personal data will not be used for any other purpose.",
      },
      {
        type: "heading",
        text: "Retention of Personal Data",
      },
      {
        type: "paragraph",
        text: "5.	Corteva retains Personal Data for as long as needed or permitted considering the purpose(s) for which it was obtained and consistent with applicable law.  The criteria used to determine our retention periods include: ",
      },
      {
        type: "list",
        items: [
          "I.	The length of time Corteva has an ongoing relationship with you and the length of time thereafter during which we may have a legitimate need to reference your Personal Data to address issues that may arise.",
          "II.	Whether there is a legal obligation to which Corteva is subject (for example, certain laws require Corteva to keep records of your transactions for a certain period before we can delete them).",
          "III.	Whether retention is advisable considering Corteva’s legal position (such as in regard to applicable statutes of limitations, litigation, or regulatory investigations). We will process your personal data only till the purposes mentioned are served:",
        ],
      },
      {
        type: "list",
        items: [
          "a)	Name, Phone No. and Email will be retained only till you remain our customer.",
          "b)	Area/Location will be retained only goods and services have been delivered.",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "Your Privacy Rights",
      },
      {
        type: "paragraph",
        text: "6.	You can withdraw your consent for processing of your personal data at any time, by clicking here https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in and following the steps. If you do so, your personal data will be erased, unless there is any legal requirement to retain it.",
      },
      {
        type: "paragraph",
        text: "7.	You may exercise your rights, raise any questions regarding the processing of your personal data, or register a grievance by contacting us at: https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html  Customer Information Center, Corteva AgriScience, 12th floor, Atria, V Ascendas IT park, Madhapur, Hyderabad 500081 or 1860 1800 186. If your grievance is not resolved by us, you may lodge a complaint with the Data Protection Board of India in the manner prescribed under applicable law.",
      },
      {
        type: "paragraph",
        text: "I confirm that I have read and understood the Privacy Notice and I hereby provide my consent for the collection and processing of the Personal Data as stated above.",
        emphasis: true,
      },
    ],
  },
  bn: {
    title: "গোপনীয়তা এবং সম্মতি বিজ্ঞপ্তি",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1.এই বিজ্ঞপ্তির মাধ্যমে আপনাকে জানানো হচ্ছে যে আমরা, Corteva Agriscience India Private Limited, এর মূল কোম্পানি এবং সহযোগী প্রতিষ্ঠানসমূহ ('Corteva Agriscience'), কীভাবে আপনার ব্যক্তিগত তথ্য প্রক্রিয়া করতে চাই, যাতে আপনি সচেতনভাবে আপনার সম্মতি প্রদান করতে পারেন। ",
      },
      {
        type: "heading",
        text: "ব্যক্তিগত তথ্য সংগ্রহ ও প্রক্রিয়াকরণ",
      },
      {
        type: "paragraph",
        text: "2. Corteva আপনার সাথে কীভাবে যোগাযোগ করে এবং আপনি কী তথ্য প্রদান করেন তার উপর ভিত্তি করে সংগ্রহকৃত ব্যক্তিগত তথ্যের ধরন পরিবর্তিত হতে পারে। এই বিজ্ঞপ্তিতে উল্লেখিত উদ্দেশ্যে শুধুমাত্র নিম্নলিখিত তথ্য সংগ্রহ করা হবে:",
      },
      {
        type: "list",
        items: ["I. নাম:", "II. মোবাইল নম্বর.:", "III. এলাকা/অবস্থান:"],
      },
      {
        type: "heading",
        text: "ব্যক্তিগত তথ্যের ব্যবহার",
      },
      {
        type: "paragraph",
        text: "3.	প্রযোজ্য আইন অনুযায়ী বৈধ ভিত্তি বা আপনার স্পষ্ট সম্মতির ভিত্তিতে Corteva এবং তার সেবা প্রদানকারীরা নিম্নলিখিত উদ্দেশ্যে আপনার তথ্য ব্যবহার করবে:",
      },
      {
        type: "list",
        items: [
          "I.	নাম, মোবাইল নম্বর এবং ইমেইল আপনাকে Delegate এবং Delegate Double Dhamaka Cashback Program-এর গ্রাহক হিসেবে নিবন্ধনের জন্য ব্যবহার করা হবে।",
          "II.এলাকা/অবস্থান পণ্য ও সেবা প্রদানের জন্য ব্যবহার করা হবে। "
        ],
      },
      {
        type: "paragraph",
        text: "4.	আপনার ব্যক্তিগত তথ্য ভারতের বাইরে সংরক্ষণ বা প্রক্রিয়াকরণ করা হতে পারে। উল্লেখিত উদ্দেশ্য পূরণের জন্য যতটুকু প্রয়োজন ততটুকুই তথ্য সংগ্রহ ও ব্যবহার করা হবে। অন্য কোনো উদ্দেশ্যে এই তথ্য ব্যবহার করা হবে না। ",
      },
      {
        type: "heading",
        text: "ব্যক্তিগত তথ্য সংরক্ষণ",
      },
      {
        type: "paragraph",
        text: "5.	Corteva প্রযোজ্য আইন অনুযায়ী প্রয়োজনীয় সময় পর্যন্ত ব্যক্তিগত তথ্য সংরক্ষণ করবে। ",
      },
      // {
      //   type: "list",
      //   items: [
      //     "I.	The length of time Corteva has an ongoing relationship with you and the length of time thereafter during which we may have a legitimate need to reference your Personal Data to address issues that may arise.",
      //     "II.	Whether there is a legal obligation to which Corteva is subject (for example, certain laws require Corteva to keep records of your transactions for a certain period before we can delete them).",
      //     "III.	Whether retention is advisable considering Corteva’s legal position (such as in regard to applicable statutes of limitations, litigation, or regulatory investigations). We will process your personal data only till the purposes mentioned are served:",
      //   ],
      // },
      {
        type: "list",
        items: [
          "a)	নাম, মোবাইল নম্বর এবং ইমেইল আপনি আমাদের গ্রাহক থাকা পর্যন্ত সংরক্ষিত থাকবে।",
          "b)	এলাকা/অবস্থান তথ্য পণ্য ও সেবা সরবরাহ সম্পন্ন হওয়া পর্যন্ত সংরক্ষিত থাকবে। ",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "আপনার গোপনীয়তার অধিকার",
      },
      {
        type: "paragraph",
        text: "6.	আপনি যেকোনো সময় আপনার সম্মতি প্রত্যাহার করতে পারেন: https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in সম্মতি প্রত্যাহার করলে, আইনি বাধ্যবাধকতা না থাকলে আপনার ব্যক্তিগত তথ্য মুছে ফেলা হবে।",
      },
      {
        type: "paragraph",
        text: "7.	আপনি আপনার অধিকার প্রয়োগ করতে, প্রশ্ন করতে বা অভিযোগ জানাতে যোগাযোগ করতে পারেন: https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html Customer Information Center, Corteva Agriscience, 12th Floor, Atria, V Ascendas IT Park, Madhapur, Hyderabad - 50008 ফোন: 1860 1800 186",
      },
      {
        type: "paragraph",
        text: "আমি নিশ্চিত করছি যে আমি গোপনীয়তা বিজ্ঞপ্তিটি পড়েছি এবং বুঝেছি, এবং উপরোক্ত বর্ণনা অনুযায়ী আমার ব্যক্তিগত তথ্য সংগ্রহ ও প্রক্রিয়াকরণের জন্য আমার সম্মতি প্রদান করছি।",
        emphasis: true,
      },
    ],
  },
  or: {
    title: "ଗୋପନୀୟତା ଏବଂ ସମ୍ମତି ସୂଚନା",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1.	ଏହି ସୂଚନା ଦ୍ୱାରା ଆପଣଙ୍କୁ ଜଣାଯାଉଛି ଯେ ଆମେ, Corteva Agriscience India Private Limited, ଏହାର ମୂଳ କମ୍ପାନୀ ଏବଂ ସହଯୋଗୀ ସଂସ୍ଥାଗୁଡ଼ିକ ('Corteva Agriscience'), କିପରି ଆପଣଙ୍କ ବ୍ୟକ୍ତିଗତ ତଥ୍ୟ ପ୍ରକ୍ରିୟାକରଣ କରିବାକୁ ଚାହୁଁଛୁ ତାହା ସୂଚନା ଦେଉଛୁ, ଯାହା ଫଳରେ ଆପଣ ସଚେତନ ଭାବରେ ସମ୍ମତି ପ୍ରଦାନ କରିପାରିବେ। ",
      },
      {
        type: "heading",
        text: "ସଂଗ୍ରହ ଓ ପ୍ରକ୍ରିୟାକରଣ ହେଉଥିବା ବ୍ୟକ୍ତିଗତ ତଥ୍ୟ",
      },
      {
        type: "paragraph",
        text: "2.	Corteva ସହ ଆପଣଙ୍କର ସମ୍ପର୍କ ଏବଂ ଆପଣ ପ୍ରଦାନ କରୁଥିବା ସୂଚନା ଅନୁସାରେ ସଂଗ୍ରହ ହେଉଥିବା ତଥ୍ୟ ଭିନ୍ନ ହୋଇପାରେ। ଏହି ସୂଚନାରେ ଉଲ୍ଲେଖିତ ଉଦ୍ଦେଶ୍ୟ ପାଇଁ କେବଳ ନିମ୍ନଲିଖିତ ତଥ୍ୟ ସଂଗ୍ରହ କରାଯିବ:",
      },
      {
        type: "list",
        items: ["I. ନାମ:", "II. ମୋବାଇଲ୍ ନମ୍ବର:", "III. ଅଞ୍ଚଳ/ଠିକଣା:"],
      },
      {
        type: "heading",
        text: "ବ୍ୟକ୍ତିଗତ ତଥ୍ୟର ପ୍ରକ୍ରିୟାକରଣ",
      },
      {
        type: "paragraph",
        text: "3.	ପ୍ରଯୋଜ୍ୟ ଆଇନ ଅନୁସାରେ ବୈଧ ଆଧାର କିମ୍ବା ଆପଣଙ୍କ ସ୍ପଷ୍ଟ ସମ୍ମତି ସହିତ, Corteva ଏବଂ ଏହାର ସେବା ପ୍ରଦାନକାରୀମାନେ ନିମ୍ନୋଲ୍ଲେଖିତ ଉଦ୍ଦେଶ୍ୟରେ ତଥ୍ୟ ବ୍ୟବହାର କରିବେ:",
      },
      {
        type: "list",
        items: [
          "I.	ନାମ, ମୋବାଇଲ୍ ନମ୍ବର ଏବଂ ଇମେଲ୍ ଆପଣଙ୍କୁ Delegate ଏବଂ Delegate Double Dhamaka Cashback Program ର ଗ୍ରାହକ ଭାବେ ପଞ୍ଜିକୃତ କରିବା ପାଇଁ ବ୍ୟବହାର ହେବ।",
          "II. ଅଞ୍ଚଳ/ଠିକଣା ପଣ୍ୟ ଓ ସେବା ପ୍ରଦାନ ପାଇଁ ବ୍ୟବହାର ହେବ। "
        ],
      },
      {
        type: "paragraph",
        text: "4.	ଆପଣଙ୍କ ବ୍ୟକ୍ତିଗତ ତଥ୍ୟ ଭାରତ ବାହାରେ ସଂରକ୍ଷିତ କିମ୍ବା ପ୍ରକ୍ରିୟାକରଣ ହୋଇପାରେ। ଉଲ୍ଲେଖିତ ଉଦ୍ଦେଶ୍ୟ ପାଇଁ ଯେତେକି ଆବଶ୍ୟକ, ସେତେକି ତଥ୍ୟ ମାତ୍ର ସଂଗ୍ରହ ଓ ବ୍ୟବହାର କରାଯିବ। ଅନ୍ୟ କୌଣସି ଉଦ୍ଦେଶ୍ୟ ପାଇଁ ଏହା ବ୍ୟବହୃତ ହେବ ନାହିଁ। ",
      },
      {
        type: "heading",
        text: "ବ୍ୟକ୍ତିଗତ ତଥ୍ୟର ସଂରକ୍ଷଣ",
      },
      {
        type: "paragraph",
        text: "5. Corteva ପ୍ରଯୋଜ୍ୟ ଆଇନ ଅନୁଯାୟୀ ଆବଶ୍ୟକ ସମୟ ପର୍ଯ୍ୟନ୍ତ ବ୍ୟକ୍ତିଗତ ତଥ୍ୟ ସଂରକ୍ଷଣ କରିବ।",
      },
      // {
      //   type: "list",
      //   items: [
      //     "I.	The length of time Corteva has an ongoing relationship with you and the length of time thereafter during which we may have a legitimate need to reference your Personal Data to address issues that may arise.",
      //     "II.	Whether there is a legal obligation to which Corteva is subject (for example, certain laws require Corteva to keep records of your transactions for a certain period before we can delete them).",
      //     "III.	Whether retention is advisable considering Corteva’s legal position (such as in regard to applicable statutes of limitations, litigation, or regulatory investigations). We will process your personal data only till the purposes mentioned are served:",
      //   ],
      // },
      {
        type: "list",
        items: [
          "a)	ନାମ, ମୋବାଇଲ୍ ନମ୍ବର ଏବଂ ଇମେଲ୍ ଆପଣ ଆମର ଗ୍ରାହକ ଥିବା ପର୍ଯ୍ୟନ୍ତ ସଂରକ୍ଷିତ ରହିବ।",
          "b)	ଅଞ୍ଚଳ/ଠିକଣା ତଥ୍ୟ ପଣ୍ୟ ଏବଂ ସେବା ପ୍ରଦାନ ସମାପ୍ତ ହେବା ପର୍ଯ୍ୟନ୍ତ ରଖାଯିବ। ",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "ଆପଣଙ୍କ ଗୋପନୀୟତା ଅଧିକାର",
      },
      {
        type: "paragraph",
        text: "6.	ଆପଣ ଯେକୌଣସି ସମୟରେ ନିମ୍ନଲିଖିତ ଲିଙ୍କ ମାଧ୍ୟମରେ ନିଜ ସମ୍ମତି ପ୍ରତ୍ୟାହାର କରିପାରିବେ: https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in ସମ୍ମତି ପ୍ରତ୍ୟାହାର କରିଲେ, ଆଇନଗତ ଆବଶ୍ୟକତା ନ ଥିଲେ ଆପଣଙ୍କ ବ୍ୟକ୍ତିଗତ ତଥ୍ୟ ବିଲୋପ କରାଯିବ।",
      },
      {
        type: "paragraph",
        text: "7.	ଅଧିକ ସୂଚନା, ପ୍ରଶ୍ନ କିମ୍ବା ଅଭିଯୋଗ ପାଇଁ: https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html Customer Information Center, Corteva Agriscience, 12th Floor, Atria, V Ascendas IT Park, Madhapur, Hyderabad - 500081 ଫୋନ୍: 1860 1800 186",
      },
      {
        type: "paragraph",
        text: "ମୁଁ ନିଶ୍ଚିତ କରୁଛି ଯେ ମୁଁ ଏହି ଗୋପନୀୟତା ସୂଚନାକୁ ପଢ଼ିଛି ଏବଂ ବୁଝିଛି, ଏବଂ ଉପରୋକ୍ତ ଭାବରେ ମୋର ବ୍ୟକ୍ତିଗତ ତଥ୍ୟ ସଂଗ୍ରହ ଏବଂ ପ୍ରକ୍ରିୟାକରଣ ପାଇଁ ମୋର ସମ୍ମତି ପ୍ରଦାନ କରୁଛି।",
        emphasis: true,
      },
    ],
  },
  mr: {
    title: "गोपनीयता आणि संमती सूचना",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1. ही सूचना तुम्हाला कळविण्यासाठी आहे की आम्ही, कॉर्टेवा ॲग्रीसायन्स इंडिया प्रायव्हेट लिमिटेड, तिची मूळ कंपनी आणि संलग्न कंपन्या ('कॉर्टेवा ॲग्रीसायन्स'), तुमचा वैयक्तिक डेटा कशा प्रकारे प्रक्रिया करू इच्छितो, जेणेकरून तुम्ही तुमची माहितीपूर्ण संमती देऊ शकता.",
      },
      {
        type: "heading",
        text: "संकलित आणि प्रक्रिया केलेला वैयक्तिक डेटा",
      },
      {
        type: "paragraph",
        text: "2. कॉर्टेवा तुमच्याकडून कोणता वैयक्तिक डेटा संकलित करेल हे तुम्ही कॉर्टेवाशी कशा प्रकारे संवाद साधता आणि त्या संवादादरम्यान तुम्ही कोणता वैयक्तिक डेटा देता यावर अवलंबून असते. सामान्यतः, कॉर्टेवा तुमच्याकडून खालील वैयक्तिक माहिती संकलित करून तिची प्रक्रिया करेल. या सूचनेत नमूद केलेल्या उद्देशांसाठी फक्त खालील वैयक्तिक डेटा संकलित केला जाईल:",
      },
      {
        type: "list",
        items: [
          "I. नाव:",
          "II. फोन क्रमांक:",
          "III. क्षेत्र/स्थान:",
        ],
      },
      {
        type: "heading",
        text: "वैयक्तिक डेटाची प्रक्रिया",
      },
      {
        type: "paragraph",
        text: "3. लागू कायद्यानुसार कॉर्टेवाकडे वैध आधार असल्यास किंवा तुमची स्पष्ट संमती असल्यास, वरील नमूद केलेला वैयक्तिक डेटा खालील उद्देशांसाठी वापरला जाईल. कॉर्टेवा आणि त्याचे सेवा प्रदाते खालील उद्देशांसाठी वैयक्तिक डेटा वापरतील:",
      },
      {
        type: "list",
        items: [
          "I. तुमचे नाव, फोन क्रमांक आणि ईमेल यांचा वापर तुम्हाला डेलीगेट आणि डेलीगेट डबल धमाका कॅशबॅक कार्यक्रमासाठी ग्राहक म्हणून नोंदणी करण्यासाठी केला जाईल.",
          "II. तुमचे क्षेत्र/स्थान वस्तू आणि सेवा पुरविण्यासाठी वापरले जाईल.",
        ],
      },
      {
        type: "paragraph",
        text: "4. तुमचा वैयक्तिक डेटा भारताबाहेर संग्रहित किंवा प्रक्रिया केला जाऊ शकतो. कॉर्टेवा वरील उद्देशांसाठी आवश्यक तितकाच वैयक्तिक डेटा संकलित आणि प्रक्रिया करते. नमूद केलेल्या उद्देशांव्यतिरिक्त तुमचा वैयक्तिक डेटा इतर कोणत्याही कारणासाठी वापरला जाणार नाही.",
      },
      {
        type: "heading",
        text: "वैयक्तिक डेटाचे जतन",
      },
      {
        type: "paragraph",
        text: "5. कॉर्टेवा वैयक्तिक डेटा तो ज्या उद्देशासाठी मिळवला आहे त्या उद्देशांच्या पूर्ततेसाठी आवश्यक किंवा कायद्याने परवानगी दिलेल्या कालावधीपर्यंत जतन करते. जतन कालावधी ठरविण्यासाठी खालील निकष वापरले जातात:",
      },
      {
        type: "list",
        items: [
          "I. कॉर्टेवासोबत तुमचे संबंध किती काळ चालू आहेत आणि त्यानंतर उद्भवू शकणाऱ्या समस्यांचे निराकरण करण्यासाठी तुमच्या वैयक्तिक डेटाची गरज किती काळ असू शकते.",
          "II. कॉर्टेवावर कोणतेही कायदेशीर बंधन लागू आहे का (उदाहरणार्थ, काही कायद्यांनुसार ठराविक कालावधीपर्यंत व्यवहारांची नोंद ठेवणे आवश्यक असते).",
          "III. लागू मर्यादा कायदे, न्यायालयीन प्रक्रिया किंवा नियामक चौकशी लक्षात घेऊन डेटा जतन करणे योग्य आहे का. तुमचा वैयक्तिक डेटा फक्त नमूद उद्देश पूर्ण होईपर्यंतच प्रक्रिया केला जाईल:",
        ],
      },
      {
        type: "list",
        items: [
          "a) तुमचे नाव, फोन क्रमांक आणि ईमेल तुम्ही आमचे ग्राहक असाल तोपर्यंतच जतन केले जातील.",
          "b) वस्तू आणि सेवा पुरवल्यानंतर तुमचे क्षेत्र/स्थान जतन केले जाणार नाही.",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "तुमचे गोपनीयता अधिकार",
      },
      {
        type: "paragraph",
        text: "6. तुम्ही कोणत्याही वेळी तुमच्या वैयक्तिक डेटाच्या प्रक्रियेसाठी दिलेली संमती मागे घेऊ शकता. त्यासाठी https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in येथे जाऊन दिलेल्या सूचनांचे पालन करा. असे केल्यास, कायदेशीर कारणास्तव डेटा जतन करणे आवश्यक नसल्यास तुमचा वैयक्तिक डेटा हटविला जाईल.",
      },
      {
        type: "paragraph",
        text: "7. तुम्ही तुमचे अधिकार वापरू शकता, तुमच्या वैयक्तिक डेटाच्या प्रक्रियेबाबत प्रश्न विचारू शकता किंवा तक्रार नोंदवू शकता. यासाठी https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html येथे किंवा ग्राहक माहिती केंद्र, कॉर्टेवा ॲग्रीसायन्स, 12 वा मजला, अट्रिया, व्ही अॅसेंडास आयटी पार्क, माधापूर, हैदराबाद - 500081 किंवा 1860 1800 186 वर संपर्क साधा. आमच्याकडून तुमच्या तक्रारीचे निराकरण न झाल्यास, लागू कायद्यानुसार तुम्ही भारताच्या डेटा संरक्षण मंडळाकडे तक्रार दाखल करू शकता.",
      },
      {
        type: "paragraph",
        text: "मी पुष्टी करतो/करते की मी ही गोपनीयता सूचना वाचली आहे, समजून घेतली आहे आणि वर नमूद केल्याप्रमाणे माझा वैयक्तिक डेटा संकलित व प्रक्रिया करण्यासाठी माझी संमती देत आहे.",
        emphasis: true,
      },
    ],
  },
  te: {
    title: "గోప్యత మరియు సమ్మతి నోటీసు",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1. ఈ నోటీసు ద్వారా మేము, కార్టేవా అగ్రిసైన్స్ ఇండియా ప్రైవేట్ లిమిటెడ్, దాని మాతృ సంస్థ మరియు అనుబంధ సంస్థలు ('కార్టేవా అగ్రిసైన్స్'), మీ వ్యక్తిగత సమాచారాన్ని ఎలా ప్రాసెస్ చేయాలనుకుంటున్నామో మీకు తెలియజేస్తున్నాము, తద్వారా మీరు పూర్తి అవగాహనతో మీ సమ్మతిని ఇవ్వగలరు.",
      },
      {
        type: "heading",
        text: "సేకరించబడే మరియు ప్రాసెస్ చేయబడే వ్యక్తిగత సమాచారం",
      },
      {
        type: "paragraph",
        text: "2. కార్టేవా మీ నుండి సేకరించే వ్యక్తిగత సమాచారం, మీరు కార్టేవాతో ఎలా పరస్పర చర్య చేస్తారో మరియు ఆ సందర్భంలో మీరు అందించే సమాచారంపై ఆధారపడి ఉంటుంది. సాధారణంగా, ఈ నోటీసులో పేర్కొన్న ప్రయోజనాల కోసం కార్టేవా మీ నుండి క్రింది వ్యక్తిగత సమాచారాన్ని మాత్రమే సేకరించి ప్రాసెస్ చేస్తుంది:",
      },
      {
        type: "list",
        items: [
          "I. పేరు:",
          "II. ఫోన్ నంబర్:",
          "III. ప్రాంతం/స్థానం:",
        ],
      },
      {
        type: "heading",
        text: "వ్యక్తిగత సమాచారం ప్రాసెసింగ్",
      },
      {
        type: "paragraph",
        text: "3. వర్తించే చట్టాల ప్రకారం కార్టేవాకు చట్టబద్ధమైన ఆధారం ఉన్నప్పుడు లేదా మీ స్పష్టమైన సమ్మతి పొందినప్పుడు, పైన పేర్కొన్న వ్యక్తిగత సమాచారం క్రింది ప్రయోజనాల కోసం ఉపయోగించబడుతుంది. కార్టేవా మరియు దాని సేవా ప్రదాతలు వ్యక్తిగత సమాచారాన్ని క్రింది విధంగా ఉపయోగిస్తారు:",
      },
      {
        type: "list",
        items: [
          "I. మీ పేరు, ఫోన్ నంబర్ మరియు ఇమెయిల్‌ను డెలిగేట్ మరియు డెలిగేట్ డబుల్ ధమాకా క్యాష్‌బ్యాక్ ప్రోగ్రామ్‌లో కస్టమర్‌గా నమోదు చేయడానికి ఉపయోగిస్తారు.",
          "II. మీ ప్రాంతం/స్థానాన్ని వస్తువులు మరియు సేవలను అందించడానికి ఉపయోగిస్తారు.",
        ],
      },
      {
        type: "paragraph",
        text: "4. మీ వ్యక్తిగత సమాచారం భారతదేశం వెలుపల కూడా నిల్వ చేయబడవచ్చు లేదా ప్రాసెస్ చేయబడవచ్చు. కార్టేవా పై పేర్కొన్న ప్రయోజనాల కోసం అవసరమైనంత వ్యక్తిగత సమాచారాన్ని మాత్రమే సేకరిస్తుంది మరియు ప్రాసెస్ చేస్తుంది. మీ వ్యక్తిగత సమాచారం ఇతర ఏ ప్రయోజనానికీ ఉపయోగించబడదు.",
      },
      {
        type: "heading",
        text: "వ్యక్తిగత సమాచారం నిల్వ",
      },
      {
        type: "paragraph",
        text: "5. వ్యక్తిగత సమాచారం సేకరించిన ఉద్దేశ్యాలను దృష్టిలో ఉంచుకొని మరియు వర్తించే చట్టాలకు అనుగుణంగా అవసరమైన లేదా అనుమతించబడినంత కాలం కార్టేవా దానిని నిల్వ ఉంచుతుంది. మా నిల్వ కాలాన్ని నిర్ణయించడానికి ఈ క్రింది ప్రమాణాలు ఉపయోగించబడతాయి:",
      },
      {
        type: "list",
        items: [
          "I. కార్టేవాతో మీ సంబంధం కొనసాగిన కాలం మరియు ఆ తరువాత మీ వ్యక్తిగత సమాచారాన్ని అవసరమైతే సూచించాల్సిన కాలం.",
          "II. కార్టేవాపై ఏదైనా చట్టపరమైన బాధ్యత ఉందా (ఉదాహరణకు, కొన్ని చట్టాల ప్రకారం మీ లావాదేవీల రికార్డులను నిర్దిష్ట కాలం వరకు భద్రపరచాలి).",
          "III. చట్టపరమైన పరిమితులు, వ్యాజ్యాలు లేదా నియంత్రణ సంస్థల దర్యాప్తులను దృష్టిలో ఉంచుకుని సమాచారం నిల్వ ఉంచడం అవసరమా. మీ వ్యక్తిగత సమాచారం పై పేర్కొన్న ప్రయోజనాలు నెరవేరే వరకు మాత్రమే ప్రాసెస్ చేయబడుతుంది:",
        ],
      },
      {
        type: "list",
        items: [
          "a) మీరు మా కస్టమర్‌గా ఉన్నంత కాలం మాత్రమే మీ పేరు, ఫోన్ నంబర్ మరియు ఇమెయిల్ నిల్వ చేయబడుతుంది.",
          "b) వస్తువులు మరియు సేవలు అందించిన తరువాత మాత్రమే మీ ప్రాంతం/స్థానం నిల్వ చేయబడుతుంది.",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "మీ గోప్యతా హక్కులు",
      },
      {
        type: "paragraph",
        text: "6. మీరు ఎప్పుడైనా మీ వ్యక్తిగత సమాచార ప్రాసెసింగ్‌కు ఇచ్చిన సమ్మతిని ఉపసంహరించుకోవచ్చు. ఇందుకోసం https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in ను సందర్శించి సూచించిన దశలను అనుసరించండి. మీరు అలా చేస్తే, చట్టపరంగా నిల్వ ఉంచాల్సిన అవసరం లేకపోతే మీ వ్యక్తిగత సమాచారం తొలగించబడుతుంది.",
      },
      {
        type: "paragraph",
        text: "7. మీ హక్కులను వినియోగించుకోవడానికి, మీ వ్యక్తిగత సమాచారం ప్రాసెసింగ్‌కు సంబంధించిన ప్రశ్నలు అడగడానికి లేదా ఫిర్యాదు నమోదు చేయడానికి https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html ను సందర్శించండి లేదా కస్టమర్ ఇన్ఫర్మేషన్ సెంటర్, కార్టేవా అగ్రిసైన్స్, 12వ అంతస్తు, అట్రియా, వి అసెండాస్ ఐటీ పార్క్, మాధాపూర్, హైదరాబాద్ – 500081 లేదా 1860 1800 186 ను సంప్రదించండి. మా ద్వారా మీ ఫిర్యాదు పరిష్కరించబడకపోతే, వర్తించే చట్టాల ప్రకారం భారత డేటా పరిరక్షణ బోర్డుకు ఫిర్యాదు చేయవచ్చు.",
      },
      {
        type: "paragraph",
        text: "నేను ఈ గోప్యతా నోటీసును చదివి, పూర్తిగా అర్థం చేసుకున్నానని మరియు పై విధంగా పేర్కొన్న నా వ్యక్తిగత సమాచార సేకరణ మరియు ప్రాసెసింగ్‌కు నా సమ్మతిని ఇస్తున్నానని ధృవీకరిస్తున్నాను.",
        emphasis: true,
      },
    ],
  },
  kn: {
    title: "ಗೌಪ್ಯತೆ ಮತ್ತು ಸಮ್ಮತಿ ಸೂಚನೆ",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1. ಈ ಸೂಚನೆಯ ಮೂಲಕ ನಾವು, ಕಾರ್ಟೇವಾ ಅಗ್ರಿಸೈನ್ಸ್ ಇಂಡಿಯಾ ಪ್ರೈವೇಟ್ ಲಿಮಿಟೆಡ್, ಅದರ ಮಾತೃ ಸಂಸ್ಥೆ ಮತ್ತು ಅಂಗಸಂಸ್ಥೆಗಳು ('ಕಾರ್ಟೇವಾ ಅಗ್ರಿಸೈನ್ಸ್'), ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಹೇಗೆ ಸಂಸ್ಕರಿಸಲು ಬಯಸುತ್ತೇವೆ ಎಂಬುದನ್ನು ನಿಮಗೆ ತಿಳಿಸುತ್ತಿದ್ದೇವೆ, ಇದರಿಂದ ನೀವು ಸಂಪೂರ್ಣ ಮಾಹಿತಿಯೊಂದಿಗೆ ನಿಮ್ಮ ಸಮ್ಮತಿಯನ್ನು ನೀಡಬಹುದು.",
      },
      {
        type: "heading",
        text: "ಸಂಗ್ರಹಿಸಲಾಗುವ ಮತ್ತು ಸಂಸ್ಕರಿಸಲಾಗುವ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ",
      },
      {
        type: "paragraph",
        text: "2. ಕಾರ್ಟೇವಾ ನಿಮ್ಮಿಂದ ಸಂಗ್ರಹಿಸುವ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಪ್ರಕಾರವು ನೀವು ಕಾರ್ಟೇವಾದೊಂದಿಗೆ ಹೇಗೆ ಸಂವಹನ ನಡೆಸುತ್ತೀರಿ ಮತ್ತು ಆ ಸಂದರ್ಭದಲ್ಲಿ ನೀವು ನೀಡುವ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಮೇಲೆ ಅವಲಂಬಿತವಾಗಿರುತ್ತದೆ. ಸಾಮಾನ್ಯವಾಗಿ, ಈ ಸೂಚನೆಯಲ್ಲಿ ಉಲ್ಲೇಖಿಸಿರುವ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಕಾರ್ಟೇವಾ ನಿಮ್ಮಿಂದ ಕೆಳಗಿನ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಮಾತ್ರ ಸಂಗ್ರಹಿಸಿ ಸಂಸ್ಕರಿಸುತ್ತದೆ:",
      },
      {
        type: "list",
        items: [
          "I. ಹೆಸರು:",
          "II. ದೂರವಾಣಿ ಸಂಖ್ಯೆ:",
          "III. ಪ್ರದೇಶ/ಸ್ಥಳ:",
        ],
      },
      {
        type: "heading",
        text: "ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಸಂಸ್ಕರಣೆ",
      },
      {
        type: "paragraph",
        text: "3. ಅನ್ವಯವಾಗುವ ಕಾನೂನಿನ ಪ್ರಕಾರ ಕಾರ್ಟೇವಾಗೆ ಕಾನೂನುಬದ್ಧ ಆಧಾರವಿದ್ದಾಗ ಅಥವಾ ನಿಮ್ಮ ಸ್ಪಷ್ಟ ಸಮ್ಮತಿ ದೊರೆತಾಗ, ಮೇಲಿನ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಕೆಳಗಿನ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಬಳಸಲಾಗುತ್ತದೆ. ಕಾರ್ಟೇವಾ ಮತ್ತು ಅದರ ಸೇವಾ ಪೂರೈಕೆದಾರರು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಈ ಕೆಳಗಿನ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಬಳಸುತ್ತಾರೆ:",
      },
      {
        type: "list",
        items: [
          "I. ನಿಮ್ಮ ಹೆಸರು, ದೂರವಾಣಿ ಸಂಖ್ಯೆ ಮತ್ತು ಇಮೇಲ್ ಅನ್ನು ಡೆಲಿಗೇಟ್ ಮತ್ತು ಡೆಲಿಗೇಟ್ ಡಬಲ್ ಧಮಾಕಾ ಕ್ಯಾಶ್‌ಬ್ಯಾಕ್ ಕಾರ್ಯಕ್ರಮದ ಗ್ರಾಹಕರಾಗಿ ನಿಮ್ಮನ್ನು ನೋಂದಾಯಿಸಲು ಬಳಸಲಾಗುತ್ತದೆ.",
          "II. ನಿಮ್ಮ ಪ್ರದೇಶ/ಸ್ಥಳವನ್ನು ಸರಕುಗಳು ಮತ್ತು ಸೇವೆಗಳನ್ನು ಒದಗಿಸಲು ಬಳಸಲಾಗುತ್ತದೆ.",
        ],
      },
      {
        type: "paragraph",
        text: "4. ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಭಾರತದಿಂದ ಹೊರಗೆಯೂ ಸಂಗ್ರಹಿಸಬಹುದು ಅಥವಾ ಸಂಸ್ಕರಿಸಬಹುದು. ಮೇಲಿನ ಉದ್ದೇಶಗಳನ್ನು ಪೂರೈಸಲು ಅಗತ್ಯವಿರುವಷ್ಟೇ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಕಾರ್ಟೇವಾ ಸಂಗ್ರಹಿಸಿ ಸಂಸ್ಕರಿಸುತ್ತದೆ. ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಬೇರೆ ಯಾವುದೇ ಉದ್ದೇಶಕ್ಕಾಗಿ ಬಳಸಲಾಗುವುದಿಲ್ಲ.",
      },
      {
        type: "heading",
        text: "ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಸಂರಕ್ಷಣೆ",
      },
      {
        type: "paragraph",
        text: "5. ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಯಾವ ಉದ್ದೇಶಕ್ಕಾಗಿ ಸಂಗ್ರಹಿಸಲಾಗಿದೆ ಎಂಬುದನ್ನು ಪರಿಗಣಿಸಿ ಹಾಗೂ ಅನ್ವಯವಾಗುವ ಕಾನೂನುಗಳಿಗೆ ಅನುಗುಣವಾಗಿ ಅಗತ್ಯವಿರುವ ಅಥವಾ ಅನುಮತಿಸಲಾದ ಅವಧಿಯವರೆಗೆ ಕಾರ್ಟೇವಾ ಅದನ್ನು ಸಂರಕ್ಷಿಸುತ್ತದೆ. ನಮ್ಮ ಸಂರಕ್ಷಣಾ ಅವಧಿಯನ್ನು ನಿರ್ಧರಿಸಲು ಈ ಕೆಳಗಿನ ಮಾನದಂಡಗಳನ್ನು ಬಳಸಲಾಗುತ್ತದೆ:",
      },
      {
        type: "list",
        items: [
          "I. ಕಾರ್ಟೇವಾದೊಂದಿಗೆ ನಿಮ್ಮ ಸಂಬಂಧ ಮುಂದುವರಿದಿರುವ ಅವಧಿ ಹಾಗೂ ನಂತರ ಉದ್ಭವಿಸಬಹುದಾದ ಸಮಸ್ಯೆಗಳನ್ನು ಪರಿಹರಿಸಲು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಉಲ್ಲೇಖಿಸುವ ಅಗತ್ಯವಿರುವ ಅವಧಿ.",
          "II. ಕಾರ್ಟೇವಾಗೆ ಯಾವುದೇ ಕಾನೂನುಬದ್ಧ ಬಾಧ್ಯತೆ ಇದೆಯೇ (ಉದಾಹರಣೆಗೆ, ಕೆಲವು ಕಾನೂನುಗಳ ಪ್ರಕಾರ ನಿಮ್ಮ ವ್ಯವಹಾರಗಳ ದಾಖಲೆಗಳನ್ನು ನಿರ್ದಿಷ್ಟ ಅವಧಿಯವರೆಗೆ ಉಳಿಸಬೇಕಾಗುತ್ತದೆ).",
          "III. ಅನ್ವಯವಾಗುವ ಮಿತಿಯ ಅವಧಿ, ನ್ಯಾಯಾಂಗ ವ್ಯಾಜ್ಯಗಳು ಅಥವಾ ನಿಯಂತ್ರಣ ತನಿಖೆಗಳನ್ನು ಪರಿಗಣಿಸಿ ಮಾಹಿತಿಯನ್ನು ಉಳಿಸಿಕೊಳ್ಳುವುದು ಸೂಕ್ತವೇ ಎಂಬುದು. ಮೇಲಿನ ಉದ್ದೇಶಗಳು ಪೂರ್ಣಗೊಳ್ಳುವವರೆಗೆ ಮಾತ್ರ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಸಂಸ್ಕರಿಸಲಾಗುತ್ತದೆ:",
        ],
      },
      {
        type: "list",
        items: [
          "a) ನೀವು ನಮ್ಮ ಗ್ರಾಹಕರಾಗಿರುವವರೆಗೆ ಮಾತ್ರ ನಿಮ್ಮ ಹೆಸರು, ದೂರವಾಣಿ ಸಂಖ್ಯೆ ಮತ್ತು ಇಮೇಲ್ ಅನ್ನು ಉಳಿಸಿಕೊಳ್ಳಲಾಗುತ್ತದೆ.",
          "b) ಸರಕುಗಳು ಮತ್ತು ಸೇವೆಗಳನ್ನು ಒದಗಿಸುವವರೆಗೆ ಮಾತ್ರ ನಿಮ್ಮ ಪ್ರದೇಶ/ಸ್ಥಳವನ್ನು ಉಳಿಸಿಕೊಳ್ಳಲಾಗುತ್ತದೆ.",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "ನಿಮ್ಮ ಗೌಪ್ಯತೆ ಹಕ್ಕುಗಳು",
      },
      {
        type: "paragraph",
        text: "6. ನೀವು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಸಂಸ್ಕರಣೆಗೆ ನೀಡಿದ ಸಮ್ಮತಿಯನ್ನು ಹಿಂತೆಗೆದುಕೊಳ್ಳಬಹುದು. ಇದಕ್ಕಾಗಿ https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in ಗೆ ಭೇಟಿ ನೀಡಿ ಮತ್ತು ಸೂಚನೆಗಳನ್ನು ಅನುಸರಿಸಿ. ನೀವು ಹೀಗೆ ಮಾಡಿದರೆ, ಕಾನೂನುಬದ್ಧವಾಗಿ ಉಳಿಸಿಕೊಳ್ಳಬೇಕಾದ ಅಗತ್ಯವಿಲ್ಲದಿದ್ದರೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಅಳಿಸಲಾಗುತ್ತದೆ.",
      },
      {
        type: "paragraph",
        text: "7. ನಿಮ್ಮ ಹಕ್ಕುಗಳನ್ನು ಚಲಾಯಿಸಲು, ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಸಂಸ್ಕರಣೆಗೆ ಸಂಬಂಧಿಸಿದ ಪ್ರಶ್ನೆಗಳನ್ನು ಕೇಳಲು ಅಥವಾ ದೂರು ದಾಖಲಿಸಲು https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html ಗೆ ಭೇಟಿ ನೀಡಿ ಅಥವಾ ಗ್ರಾಹಕ ಮಾಹಿತಿ ಕೇಂದ್ರ, ಕಾರ್ಟೇವಾ ಅಗ್ರಿಸೈನ್ಸ್, 12ನೇ ಮಹಡಿ, ಅಟ್ರಿಯಾ, ವಿ ಅಸೆಂಡಾಸ್ ಐಟಿ ಪಾರ್ಕ್, ಮಾಧಾಪುರ, ಹೈದರಾಬಾದ್ – 500081 ಅಥವಾ 1860 1800 186 ಅನ್ನು ಸಂಪರ್ಕಿಸಿ. ನಮ್ಮಿಂದ ನಿಮ್ಮ ದೂರಿಗೆ ಪರಿಹಾರ ದೊರೆಯದಿದ್ದರೆ, ಅನ್ವಯವಾಗುವ ಕಾನೂನಿನ ಪ್ರಕಾರ ಭಾರತದ ಡೇಟಾ ಸಂರಕ್ಷಣಾ ಮಂಡಳಿಗೆ ದೂರು ಸಲ್ಲಿಸಬಹುದು.",
      },
      {
        type: "paragraph",
        text: "ನಾನು ಈ ಗೌಪ್ಯತಾ ಸೂಚನೆಯನ್ನು ಓದಿ, ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೇನೆ ಮತ್ತು ಮೇಲಿನಂತೆ ವಿವರಿಸಲಾದ ನನ್ನ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಸಂಗ್ರಹಣೆ ಮತ್ತು ಸಂಸ್ಕರಣೆಗೆ ನನ್ನ ಸಮ್ಮತಿಯನ್ನು ನೀಡುತ್ತೇನೆ ಎಂದು ದೃಢೀಕರಿಸುತ್ತೇನೆ.",
        emphasis: true,
      },
    ],
  },
  pa: {
    title: "ਗੋਪਨੀਯਤਾ ਅਤੇ ਸਹਿਮਤੀ ਸੂਚਨਾ",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1. ਇਹ ਸੂਚਨਾ ਤੁਹਾਨੂੰ ਇਹ ਦੱਸਣ ਲਈ ਹੈ ਕਿ ਅਸੀਂ, ਕੋਰਟੇਵਾ ਐਗ੍ਰੀਸਾਇੰਸ ਇੰਡੀਆ ਪ੍ਰਾਈਵੇਟ ਲਿਮਿਟੇਡ, ਇਸਦੀ ਮੂਲ ਕੰਪਨੀ ਅਤੇ ਸੰਬੰਧਿਤ ਕੰਪਨੀਆਂ ('ਕੋਰਟੇਵਾ ਐਗ੍ਰੀਸਾਇੰਸ'), ਤੁਹਾਡੇ ਨਿੱਜੀ ਡਾਟੇ ਨੂੰ ਕਿਵੇਂ ਪ੍ਰਕਿਰਿਆ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹਾਂ ਤਾਂ ਜੋ ਤੁਸੀਂ ਆਪਣੀ ਜਾਣਕਾਰੀ ਦੇ ਆਧਾਰ 'ਤੇ ਸਹਿਮਤੀ ਦੇ ਸਕੋ।",
      },
      {
        type: "heading",
        text: "ਇਕੱਠਾ ਕੀਤਾ ਅਤੇ ਪ੍ਰਕਿਰਿਆ ਕੀਤਾ ਜਾਣ ਵਾਲਾ ਨਿੱਜੀ ਡਾਟਾ",
      },
      {
        type: "paragraph",
        text: "2. ਕੋਰਟੇਵਾ ਤੁਹਾਡੇ ਤੋਂ ਕਿਹੜਾ ਨਿੱਜੀ ਡਾਟਾ ਇਕੱਠਾ ਕਰੇਗੀ, ਇਹ ਇਸ ਗੱਲ 'ਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ ਕਿ ਤੁਸੀਂ ਕੋਰਟੇਵਾ ਨਾਲ ਕਿਵੇਂ ਸੰਪਰਕ ਕਰਦੇ ਹੋ ਅਤੇ ਉਸ ਦੌਰਾਨ ਤੁਸੀਂ ਕਿਹੜਾ ਨਿੱਜੀ ਡਾਟਾ ਪ੍ਰਦਾਨ ਕਰਦੇ ਹੋ। ਆਮ ਤੌਰ 'ਤੇ, ਕੋਰਟੇਵਾ ਇਸ ਸੂਚਨਾ ਵਿੱਚ ਦਰਸਾਏ ਉਦੇਸ਼ਾਂ ਲਈ ਤੁਹਾਡੇ ਤੋਂ ਹੇਠਾਂ ਦਿੱਤੀ ਨਿੱਜੀ ਜਾਣਕਾਰੀ ਇਕੱਠੀ ਕਰੇਗੀ ਅਤੇ ਇਸਦੀ ਪ੍ਰਕਿਰਿਆ ਕਰੇਗੀ:",
      },
      {
        type: "list",
        items: [
          "I. ਨਾਮ:",
          "II. ਫੋਨ ਨੰਬਰ:",
          "III. ਖੇਤਰ/ਸਥਾਨ:",
        ],
      },
      {
        type: "heading",
        text: "ਨਿੱਜੀ ਡਾਟੇ ਦੀ ਪ੍ਰਕਿਰਿਆ",
      },
      {
        type: "paragraph",
        text: "3. ਜਦੋਂ ਲਾਗੂ ਕਾਨੂੰਨ ਅਧੀਨ ਕੋਰਟੇਵਾ ਕੋਲ ਕਾਨੂੰਨੀ ਆਧਾਰ ਹੋਵੇ ਜਾਂ ਤੁਹਾਡੀ ਸਪਸ਼ਟ ਸਹਿਮਤੀ ਪ੍ਰਾਪਤ ਹੋਵੇ, ਤਾਂ ਉਪਰੋਕਤ ਨਿੱਜੀ ਡਾਟੇ ਨੂੰ ਹੇਠ ਲਿਖੇ ਉਦੇਸ਼ਾਂ ਲਈ ਵਰਤਿਆ ਜਾਵੇਗਾ। ਕੋਰਟੇਵਾ ਅਤੇ ਇਸਦੇ ਸੇਵਾ ਪ੍ਰਦਾਤਾ ਨਿੱਜੀ ਡਾਟੇ ਨੂੰ ਹੇਠ ਲਿਖੇ ਉਦੇਸ਼ਾਂ ਲਈ ਵਰਤਣਗੇ:",
      },
      {
        type: "list",
        items: [
          "I. ਤੁਹਾਡਾ ਨਾਮ, ਫੋਨ ਨੰਬਰ ਅਤੇ ਈਮੇਲ ਤੁਹਾਨੂੰ ਡੈਲੀਗੇਟ ਅਤੇ ਡੈਲੀਗੇਟ ਡਬਲ ਧਮਾਕਾ ਕੈਸ਼ਬੈਕ ਪ੍ਰੋਗਰਾਮ ਦੇ ਗਾਹਕ ਵਜੋਂ ਰਜਿਸਟਰ ਕਰਨ ਲਈ ਵਰਤੇ ਜਾਣਗੇ।",
          "II. ਤੁਹਾਡੇ ਖੇਤਰ/ਸਥਾਨ ਦੀ ਵਰਤੋਂ ਸਮਾਨ ਅਤੇ ਸੇਵਾਵਾਂ ਪ੍ਰਦਾਨ ਕਰਨ ਲਈ ਕੀਤੀ ਜਾਵੇਗੀ।",
        ],
      },
      {
        type: "paragraph",
        text: "4. ਤੁਹਾਡਾ ਨਿੱਜੀ ਡਾਟਾ ਭਾਰਤ ਤੋਂ ਬਾਹਰ ਵੀ ਸੰਭਾਲਿਆ ਜਾਂ ਪ੍ਰਕਿਰਿਆ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ। ਕੋਰਟੇਵਾ ਸਿਰਫ਼ ਉਨ੍ਹਾਂ ਉਦੇਸ਼ਾਂ ਲਈ ਲੋੜੀਂਦਾ ਨਿੱਜੀ ਡਾਟਾ ਹੀ ਇਕੱਠਾ ਅਤੇ ਪ੍ਰਕਿਰਿਆ ਕਰਦੀ ਹੈ। ਤੁਹਾਡਾ ਨਿੱਜੀ ਡਾਟਾ ਕਿਸੇ ਹੋਰ ਉਦੇਸ਼ ਲਈ ਵਰਤਿਆ ਨਹੀਂ ਜਾਵੇਗਾ।",
      },
      {
        type: "heading",
        text: "ਨਿੱਜੀ ਡਾਟੇ ਦੀ ਸੰਭਾਲ",
      },
      {
        type: "paragraph",
        text: "5. ਕੋਰਟੇਵਾ ਨਿੱਜੀ ਡਾਟੇ ਨੂੰ ਉਸ ਸਮੇਂ ਤੱਕ ਸੰਭਾਲਦੀ ਹੈ ਜਦੋਂ ਤੱਕ ਇਹ ਉਸ ਉਦੇਸ਼ ਲਈ ਲੋੜੀਂਦਾ ਜਾਂ ਕਾਨੂੰਨੀ ਤੌਰ 'ਤੇ ਮਨਜ਼ੂਰਸ਼ੁਦਾ ਹੋਵੇ ਜਿਸ ਲਈ ਇਹ ਪ੍ਰਾਪਤ ਕੀਤਾ ਗਿਆ ਸੀ। ਸਾਡੀ ਸੰਭਾਲ ਮਿਆਦ ਨਿਰਧਾਰਤ ਕਰਨ ਲਈ ਹੇਠ ਲਿਖੇ ਮਾਪਦੰਡ ਵਰਤੇ ਜਾਂਦੇ ਹਨ:",
      },
      {
        type: "list",
        items: [
          "I. ਕੋਰਟੇਵਾ ਨਾਲ ਤੁਹਾਡੇ ਸੰਬੰਧ ਦੀ ਮਿਆਦ ਅਤੇ ਉਸ ਤੋਂ ਬਾਅਦ ਦੀ ਉਹ ਮਿਆਦ ਜਿਸ ਦੌਰਾਨ ਤੁਹਾਡੇ ਨਿੱਜੀ ਡਾਟੇ ਦੀ ਲੋੜ ਪੈ ਸਕਦੀ ਹੈ।",
          "II. ਕੀ ਕੋਰਟੇਵਾ ਉੱਤੇ ਕੋਈ ਕਾਨੂੰਨੀ ਜ਼ਿੰਮੇਵਾਰੀ ਲਾਗੂ ਹੁੰਦੀ ਹੈ (ਉਦਾਹਰਨ ਲਈ, ਕੁਝ ਕਾਨੂੰਨਾਂ ਅਧੀਨ ਲੈਣ-ਦੇਣ ਦੇ ਰਿਕਾਰਡ ਨਿਰਧਾਰਤ ਸਮੇਂ ਤੱਕ ਰੱਖਣੇ ਲਾਜ਼ਮੀ ਹੁੰਦੇ ਹਨ)।",
          "III. ਕੀ ਕਾਨੂੰਨੀ ਸੀਮਾਵਾਂ, ਮੁਕੱਦਮਿਆਂ ਜਾਂ ਨਿਯਮਕ ਜਾਂਚਾਂ ਨੂੰ ਧਿਆਨ ਵਿੱਚ ਰੱਖਦੇ ਹੋਏ ਡਾਟਾ ਸੰਭਾਲਣਾ ਉਚਿਤ ਹੈ। ਤੁਹਾਡਾ ਨਿੱਜੀ ਡਾਟਾ ਸਿਰਫ਼ ਉਪਰੋਕਤ ਉਦੇਸ਼ ਪੂਰੇ ਹੋਣ ਤੱਕ ਹੀ ਪ੍ਰਕਿਰਿਆ ਕੀਤਾ ਜਾਵੇਗਾ:",
        ],
      },
      {
        type: "list",
        items: [
          "a) ਤੁਹਾਡਾ ਨਾਮ, ਫੋਨ ਨੰਬਰ ਅਤੇ ਈਮੇਲ ਸਿਰਫ਼ ਉਸ ਸਮੇਂ ਤੱਕ ਰੱਖੇ ਜਾਣਗੇ ਜਦੋਂ ਤੱਕ ਤੁਸੀਂ ਸਾਡੇ ਗਾਹਕ ਹੋ।",
          "b) ਤੁਹਾਡਾ ਖੇਤਰ/ਸਥਾਨ ਸਿਰਫ਼ ਸਮਾਨ ਅਤੇ ਸੇਵਾਵਾਂ ਪ੍ਰਦਾਨ ਹੋਣ ਤੱਕ ਹੀ ਰੱਖਿਆ ਜਾਵੇਗਾ।",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "ਤੁਹਾਡੇ ਗੋਪਨੀਯਤਾ ਅਧਿਕਾਰ",
      },
      {
        type: "paragraph",
        text: "6. ਤੁਸੀਂ ਕਿਸੇ ਵੀ ਸਮੇਂ ਆਪਣੇ ਨਿੱਜੀ ਡਾਟੇ ਦੀ ਪ੍ਰਕਿਰਿਆ ਲਈ ਦਿੱਤੀ ਸਹਿਮਤੀ ਵਾਪਸ ਲੈ ਸਕਦੇ ਹੋ। ਇਸ ਲਈ https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in 'ਤੇ ਜਾ ਕੇ ਦਿੱਤੇ ਕਦਮਾਂ ਦੀ ਪਾਲਣਾ ਕਰੋ। ਜੇ ਤੁਸੀਂ ਅਜਿਹਾ ਕਰਦੇ ਹੋ, ਤਾਂ ਤੁਹਾਡਾ ਨਿੱਜੀ ਡਾਟਾ ਮਿਟਾ ਦਿੱਤਾ ਜਾਵੇਗਾ, ਜੇਕਰ ਉਸਨੂੰ ਕਾਨੂੰਨੀ ਤੌਰ 'ਤੇ ਸੰਭਾਲਣਾ ਲਾਜ਼ਮੀ ਨਾ ਹੋਵੇ।",
      },
      {
        type: "paragraph",
        text: "7. ਤੁਸੀਂ ਆਪਣੇ ਅਧਿਕਾਰਾਂ ਦੀ ਵਰਤੋਂ ਕਰ ਸਕਦੇ ਹੋ, ਆਪਣੇ ਨਿੱਜੀ ਡਾਟੇ ਦੀ ਪ੍ਰਕਿਰਿਆ ਬਾਰੇ ਸਵਾਲ ਪੁੱਛ ਸਕਦੇ ਹੋ ਜਾਂ ਸ਼ਿਕਾਇਤ ਦਰਜ ਕਰਵਾ ਸਕਦੇ ਹੋ। ਇਸ ਲਈ https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html 'ਤੇ ਜਾਓ ਜਾਂ ਗਾਹਕ ਜਾਣਕਾਰੀ ਕੇਂਦਰ, ਕੋਰਟੇਵਾ ਐਗ੍ਰੀਸਾਇੰਸ, 12ਵੀਂ ਮੰਜ਼ਿਲ, ਐਟਰੀਆ, ਵੀ ਅਸੈਂਡਾਸ ਆਈਟੀ ਪਾਰਕ, ਮਾਧਾਪੁਰ, ਹੈਦਰਾਬਾਦ – 500081 ਜਾਂ 1860 1800 186 'ਤੇ ਸੰਪਰਕ ਕਰੋ। ਜੇਕਰ ਤੁਹਾਡੀ ਸ਼ਿਕਾਇਤ ਦਾ ਹੱਲ ਨਹੀਂ ਹੁੰਦਾ, ਤਾਂ ਤੁਸੀਂ ਲਾਗੂ ਕਾਨੂੰਨ ਅਨੁਸਾਰ ਭਾਰਤ ਦੇ ਡਾਟਾ ਪ੍ਰੋਟੈਕਸ਼ਨ ਬੋਰਡ ਕੋਲ ਸ਼ਿਕਾਇਤ ਦਰਜ ਕਰ ਸਕਦੇ ਹੋ।",
      },
      {
        type: "paragraph",
        text: "ਮੈਂ ਪੁਸ਼ਟੀ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ ਕਿ ਮੈਂ ਇਸ ਗੋਪਨੀਯਤਾ ਸੂਚਨਾ ਨੂੰ ਪੜ੍ਹ ਲਿਆ ਹੈ ਅਤੇ ਸਮਝ ਲਿਆ ਹੈ ਅਤੇ ਉਪਰੋਕਤ ਅਨੁਸਾਰ ਮੇਰੇ ਨਿੱਜੀ ਡਾਟੇ ਦੇ ਇਕੱਠਾ ਕਰਨ ਅਤੇ ਪ੍ਰਕਿਰਿਆ ਲਈ ਆਪਣੀ ਸਹਿਮਤੀ ਦਿੰਦਾ/ਦਿੰਦੀ ਹਾਂ।",
        emphasis: true,
      },
    ],
  },
  gu: {
    title: "ગોપનીયતા અને સંમતિ સૂચના",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1. આ સૂચનાનો હેતુ તમને જાણ કરવાનો છે કે અમે, કોર્ટેવા એગ્રિસાયન્સ ઈન્ડિયા પ્રાઈવેટ લિમિટેડ, તેની મૂળ કંપની અને તેની સંલગ્ન કંપનીઓ ('કોર્ટેવા એગ્રિસાયન્સ'), તમારા વ્યક્તિગત ડેટાની કેવી રીતે પ્રક્રિયા કરવા માંગીએ છીએ, જેથી તમે સંપૂર્ણ માહિતી સાથે તમારી સંમતિ આપી શકો.",
      },
      {
        type: "heading",
        text: "એકત્રિત અને પ્રક્રિયા કરવામાં આવતો વ્યક્તિગત ડેટા",
      },
      {
        type: "paragraph",
        text: "2. કોર્ટેવા તમારા પાસેથી કયા પ્રકારનો વ્યક્તિગત ડેટા એકત્રિત કરે છે તે તમે કોર્ટેવા સાથે કેવી રીતે સંપર્ક કરો છો અને તે દરમિયાન તમે કયો વ્યક્તિગત ડેટા પ્રદાન કરો છો તેના પર આધાર રાખે છે. સામાન્ય રીતે, આ સૂચનામાં જણાવાયેલા હેતુઓ માટે કોર્ટેવા તમારા પાસેથી નીચે દર્શાવેલ વ્યક્તિગત માહિતી એકત્રિત કરશે અને તેની પ્રક્રિયા કરશે:",
      },
      {
        type: "list",
        items: [
          "I. નામ:",
          "II. ફોન નંબર:",
          "III. વિસ્તાર/સ્થાન:",
        ],
      },
      {
        type: "heading",
        text: "વ્યક્તિગત ડેટાની પ્રક્રિયા",
      },
      {
        type: "paragraph",
        text: "3. લાગુ પડતા કાયદા હેઠળ કોર્ટેવા પાસે કાનૂની આધાર હોય અથવા તમારી સ્પષ્ટ સંમતિ પ્રાપ્ત થઈ હોય ત્યારે ઉપરોક્ત વ્યક્તિગત માહિતીનો નીચે મુજબના હેતુઓ માટે ઉપયોગ કરવામાં આવશે. કોર્ટેવા અને તેના સેવા પ્રદાતાઓ વ્યક્તિગત ડેટાનો નીચેના હેતુઓ માટે ઉપયોગ કરશે:",
      },
      {
        type: "list",
        items: [
          "I. તમારું નામ, ફોન નંબર અને ઈમેલનો ઉપયોગ તમને ડેલિગેટ અને ડેલિગેટ ડબલ ધમાકા કેશબેક કાર્યક્રમમાં ગ્રાહક તરીકે નોંધણી કરવા માટે કરવામાં આવશે.",
          "II. તમારા વિસ્તાર/સ્થાનનો ઉપયોગ માલ અને સેવાઓ પ્રદાન કરવા માટે કરવામાં આવશે.",
        ],
      },
      {
        type: "paragraph",
        text: "4. તમારો વ્યક્તિગત ડેટા ભારતની બહાર પણ સંગ્રહિત અથવા પ્રક્રિયા કરવામાં આવી શકે છે. કોર્ટેવા માત્ર ઉપરોક્ત હેતુઓ માટે જરૂરી હોય તેટલો જ વ્યક્તિગત ડેટા એકત્રિત અને પ્રક્રિયા કરે છે. તમારા વ્યક્તિગત ડેટાનો અન્ય કોઈ હેતુ માટે ઉપયોગ કરવામાં આવશે નહીં.",
      },
      {
        type: "heading",
        text: "વ્યક્તિગત ડેટાનું જાળવણી",
      },
      {
        type: "paragraph",
        text: "5. કોર્ટેવા વ્યક્તિગત ડેટાને તે જે હેતુ માટે મેળવવામાં આવ્યો હોય તે હેતુ પૂર્ણ થાય ત્યાં સુધી અથવા લાગુ કાયદા અનુસાર જરૂરી અથવા મંજૂર સમયગાળા સુધી જાળવી રાખે છે. અમારી જાળવણીની અવધિ નક્કી કરવા માટે નીચેના માપદંડોનો ઉપયોગ કરવામાં આવે છે:",
      },
      {
        type: "list",
        items: [
          "I. કોર્ટેવા સાથે તમારો સંબંધ કેટલો સમય ચાલુ રહે છે અને ત્યારબાદ ઉદ્ભવતી સમસ્યાઓના નિરાકરણ માટે તમારા વ્યક્તિગત ડેટાની જરૂર કેટલા સમય સુધી રહી શકે છે.",
          "II. કોર્ટેવા પર કોઈ કાનૂની જવાબદારી લાગુ પડે છે કે નહીં (ઉદાહરણ તરીકે, કેટલાક કાયદાઓ હેઠળ અમુક સમયગાળા સુધી વ્યવહારોના રેકોર્ડ રાખવા જરૂરી હોય છે).",
          "III. કાનૂની મર્યાદા, કાનૂની કાર્યવાહી અથવા નિયમનકારી તપાસને ધ્યાનમાં રાખીને ડેટા જાળવી રાખવો યોગ્ય છે કે નહીં. તમારા વ્યક્તિગત ડેટાની પ્રક્રિયા ઉપરોક્ત હેતુઓ પૂર્ણ થાય ત્યાં સુધી જ કરવામાં આવશે:",
        ],
      },
      {
        type: "list",
        items: [
          "a) તમારું નામ, ફોન નંબર અને ઈમેલ માત્ર તમે અમારા ગ્રાહક હો ત્યાં સુધી જ રાખવામાં આવશે.",
          "b) તમારો વિસ્તાર/સ્થાન માત્ર માલ અને સેવાઓ પૂરી પાડવામાં આવે ત્યાં સુધી જ રાખવામાં આવશે.",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "તમારા ગોપનીયતા અધિકારો",
      },
      {
        type: "paragraph",
        text: "6. તમે કોઈપણ સમયે તમારા વ્યક્તિગત ડેટાની પ્રક્રિયા માટે આપેલી સંમતિ પાછી ખેંચી શકો છો. તે માટે https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in પર જઈને આપેલ સૂચનાઓનું પાલન કરો. જો તમે આમ કરશો, તો કાયદાકીય કારણોસર જાળવી રાખવાની જરૂરિયાત ન હોય તો તમારો વ્યક્તિગત ડેટા કાઢી નાખવામાં આવશે.",
      },
      {
        type: "paragraph",
        text: "7. તમે તમારા અધિકારોનો ઉપયોગ કરી શકો છો, તમારા વ્યક્તિગત ડેટાની પ્રક્રિયા અંગે પ્રશ્નો પૂછી શકો છો અથવા ફરિયાદ નોંધાવી શકો છો. તેના માટે https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html ની મુલાકાત લો અથવા ગ્રાહક માહિતી કેન્દ્ર, કોર્ટેવા એગ્રિસાયન્સ, 12મો માળ, એટ્રિયા, વી એસેન્ડાસ આઈટી પાર્ક, માધાપુર, હૈદરાબાદ – 500081 અથવા 1860 1800 186 પર સંપર્ક કરો. જો તમારી ફરિયાદનું નિરાકરણ ન આવે, તો તમે લાગુ કાયદા મુજબ ભારતના ડેટા પ્રોટેક્શન બોર્ડ સમક્ષ ફરિયાદ નોંધાવી શકો છો.",
      },
      {
        type: "paragraph",
        text: "હું ખાતરી આપું છું કે મેં આ ગોપનીયતા સૂચના વાંચી અને સમજી છે અને ઉપર જણાવ્યા મુજબ મારા વ્યક્તિગત ડેટાના સંગ્રહ અને પ્રક્રિયા માટે મારી સંમતિ આપું છું.",
        emphasis: true,
      },
    ],
  },
  ta: {
    title: "தனியுரிமை மற்றும் ஒப்புதல் அறிவிப்பு",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1. இந்த அறிவிப்பின் நோக்கம், நாங்கள், கோர்டேவா அக்ரிசயன்ஸ் இந்தியா பிரைவேட் லிமிடெட், அதன் தாய் நிறுவனம் மற்றும் இணை நிறுவனங்கள் ('கோர்டேவா அக்ரிசயன்ஸ்'), உங்கள் தனிப்பட்ட தரவை எவ்வாறு செயலாக்க விரும்புகிறோம் என்பதை உங்களுக்குத் தெரிவிப்பதாகும், இதன் மூலம் நீங்கள் முழுமையான தகவலறிந்த ஒப்புதலை வழங்க முடியும்.",
      },
      {
        type: "heading",
        text: "சேகரிக்கப்படும் மற்றும் செயலாக்கப்படும் தனிப்பட்ட தரவு",
      },
      {
        type: "paragraph",
        text: "2. கோர்டேவா உங்களிடமிருந்து சேகரிக்கும் தனிப்பட்ட தரவின் வகைகள், நீங்கள் கோர்டேவாவுடன் எவ்வாறு தொடர்பு கொள்கிறீர்கள் மற்றும் அந்த தொடர்புகளின் போது நீங்கள் வழங்கும் தனிப்பட்ட தரவைப் பொறுத்து மாறுபடும். பொதுவாக, இந்த அறிவிப்பில் குறிப்பிடப்பட்டுள்ள நோக்கங்களுக்காக, கோர்டேவா உங்களிடமிருந்து பின்வரும் தனிப்பட்ட தகவல்களை மட்டுமே சேகரித்து செயலாக்கும்:",
      },
      {
        type: "list",
        items: [
          "I. பெயர்:",
          "II. தொலைபேசி எண்:",
          "III. பகுதி / இருப்பிடம்:",
        ],
      },
      {
        type: "heading",
        text: "தனிப்பட்ட தரவின் செயலாக்கம்",
      },
      {
        type: "paragraph",
        text: "3. பொருந்தக்கூடிய சட்டத்தின் கீழ் கோர்டேவாவிற்கு சட்டபூர்வமான அடிப்படை இருந்தாலோ அல்லது உங்கள் வெளிப்படையான ஒப்புதல் பெறப்பட்டாலோ, மேலே குறிப்பிடப்பட்டுள்ள தனிப்பட்ட தரவு பின்வரும் நோக்கங்களுக்காக பயன்படுத்தப்படும். கோர்டேவா மற்றும் அதன் சேவை வழங்குநர்கள் தனிப்பட்ட தரவை பின்வரும் நோக்கங்களுக்காக பயன்படுத்துவார்கள்:",
      },
      {
        type: "list",
        items: [
          "I. உங்கள் பெயர், தொலைபேசி எண் மற்றும் மின்னஞ்சல் முகவரி, டெலிகேட் மற்றும் டெலிகேட் டபுள் தமாகா கேஷ்பேக் திட்டத்தில் உங்களை வாடிக்கையாளராக பதிவு செய்ய பயன்படுத்தப்படும்.",
          "II. உங்கள் பகுதி / இருப்பிடம் பொருட்கள் மற்றும் சேவைகளை வழங்க பயன்படுத்தப்படும்.",
        ],
      },
      {
        type: "paragraph",
        text: "4. உங்கள் தனிப்பட்ட தரவு இந்தியாவிற்கு வெளியிலும் சேமிக்கப்படலாம் அல்லது செயலாக்கப்படலாம். மேற்கண்ட நோக்கங்களுக்குத் தேவையான அளவிலான தனிப்பட்ட தரவையே கோர்டேவா சேகரித்து செயலாக்கும். உங்கள் தனிப்பட்ட தரவு வேறு எந்த நோக்கத்திற்கும் பயன்படுத்தப்படாது.",
      },
      {
        type: "heading",
        text: "தனிப்பட்ட தரவை பாதுகாத்தல்",
      },
      {
        type: "paragraph",
        text: "5. தனிப்பட்ட தரவு சேகரிக்கப்பட்ட நோக்கங்களை கருத்தில் கொண்டு, பொருந்தக்கூடிய சட்டங்களின் அடிப்படையில் தேவையான அல்லது அனுமதிக்கப்பட்ட காலம் வரை கோர்டேவா தனிப்பட்ட தரவை பாதுகாத்து வைத்திருக்கும். பாதுகாப்பு காலத்தை நிர்ணயிக்க பின்வரும் அளவுகோல்கள் பயன்படுத்தப்படுகின்றன:",
      },
      {
        type: "list",
        items: [
          "I. கோர்டேவாவுடன் உங்களுக்குள்ள உறவு நீடிக்கும் காலம் மற்றும் அதன் பின்னர் உங்கள் தனிப்பட்ட தரவை மேற்கோள் காட்ட வேண்டிய அவசியம் ஏற்படக்கூடிய காலம்.",
          "II. கோர்டேவாவிற்கு ஏதேனும் சட்டப்பூர்வமான கடமை உள்ளதா (உதாரணமாக, சில சட்டங்களின்படி குறிப்பிட்ட காலத்திற்கு பரிவர்த்தனை பதிவுகளை பாதுகாக்க வேண்டிய அவசியம் உள்ளது).",
          "III. பொருந்தக்கூடிய காலவரம்புகள், வழக்குகள் அல்லது ஒழுங்குமுறை விசாரணைகளை கருத்தில் கொண்டு தரவை பாதுகாப்பது பொருத்தமானதா என்பதைக் கருத்தில் கொள்ளுதல். மேலே குறிப்பிடப்பட்டுள்ள நோக்கங்கள் நிறைவேறும் வரை மட்டுமே உங்கள் தனிப்பட்ட தரவு செயலாக்கப்படும்:",
        ],
      },
      {
        type: "list",
        items: [
          "a) உங்கள் பெயர், தொலைபேசி எண் மற்றும் மின்னஞ்சல் முகவரி நீங்கள் எங்கள் வாடிக்கையாளராக இருக்கும் வரை மட்டுமே பாதுகாக்கப்படும்.",
          "b) உங்கள் பகுதி / இருப்பிடம் பொருட்கள் மற்றும் சேவைகள் வழங்கப்படும் வரை மட்டுமே பாதுகாக்கப்படும்.",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "உங்கள் தனியுரிமை உரிமைகள்",
      },
      {
        type: "paragraph",
        text: "6. உங்கள் தனிப்பட்ட தரவை செயலாக்குவதற்காக வழங்கியுள்ள ஒப்புதலை நீங்கள் எந்த நேரத்திலும் திரும்பப் பெறலாம். அதற்காக https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in என்ற இணையதளத்திற்குச் சென்று வழங்கப்பட்டுள்ள வழிமுறைகளைப் பின்பற்றவும். நீங்கள் அவ்வாறு செய்தால், சட்டப்படி பாதுகாக்க வேண்டிய அவசியம் இல்லையெனில், உங்கள் தனிப்பட்ட தரவு நீக்கப்படும்.",
      },
      {
        type: "paragraph",
        text: "7. உங்கள் உரிமைகளைப் பயன்படுத்தவும், உங்கள் தனிப்பட்ட தரவின் செயலாக்கம் தொடர்பாக கேள்விகள் கேட்கவும் அல்லது புகார் அளிக்கவும் https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html என்ற இணையதளத்தைப் பார்வையிடலாம் அல்லது வாடிக்கையாளர் தகவல் மையம், கோர்டேவா அக்ரிசயன்ஸ், 12வது மாடி, அட்ரியா, வி அசென்டாஸ் ஐடி பார்க், மாதாபூர், ஹைதராபாத் – 500081 அல்லது 1860 1800 186 என்ற எண்ணைத் தொடர்புகொள்ளலாம். உங்கள் புகார் எங்களால் தீர்க்கப்படாவிட்டால், பொருந்தக்கூடிய சட்டத்தின்படி இந்திய தரவு பாதுகாப்பு வாரியத்தில் புகார் அளிக்கலாம்.",
      },
      {
        type: "paragraph",
        text: "இந்த தனியுரிமை அறிவிப்பை நான் படித்து முழுமையாக புரிந்துகொண்டுள்ளேன் என்பதை உறுதிப்படுத்துகிறேன். மேலே குறிப்பிடப்பட்டுள்ளபடி, என் தனிப்பட்ட தரவை சேகரித்து செயலாக்குவதற்கு என் ஒப்புதலை வழங்குகிறேன்.",
        emphasis: true,
      },
    ],
  },
};

export const getPrivacyConsentNotice = (lang) =>
  PRIVACY_CONSENT_NOTICE[lang] || PRIVACY_CONSENT_NOTICE.hi;
